import { render } from "./ReportIncident.vue?vue&type=template&id=6834f363"
import script from "./ReportIncident.vue?vue&type=script&lang=js"
export * from "./ReportIncident.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\cert-v3\\cert\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__